import { Navbar2,Footer2 } from "../components";
import { Outlet } from "react-router-dom";
import ScrollToTop from "../components/NewUIComponents/ScrollToTop";
const NewUILayout = () =>{
    return(
        <>
        <ScrollToTop/>
        <Navbar2/>
        <Outlet/>
        <Footer2/>
        </>
    )
}

export default NewUILayout;